import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Currency formatting
export function formatCurrency(value) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

export function formatCurrencyFull(value) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatPercent(value) {
  return `${value.toFixed(1)}%`;
}

export function formatNumber(value) {
  return new Intl.NumberFormat('en-US').format(value);
}

// Time formatting for Echo
export function formatTime(time) {
  const [hours, minutes] = time.split(':');
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
}

export function formatDate(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { 
    weekday: 'short', 
    month: 'short', 
    day: 'numeric' 
  });
}

// revQ status colors
export function getStatusColor(status) {
  const colors = {
    paid: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
    pending: { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200' },
    denied: { bg: 'bg-red-50', text: 'text-red-700', border: 'border-red-200' },
    appealed: { bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-200' },
    success: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
    warning: { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200' },
    error: { bg: 'bg-red-50', text: 'text-red-700', border: 'border-red-200' },
    info: { bg: 'bg-blue-50', text: 'text-blue-700', border: 'border-blue-200' },
    excellent: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
    good: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
    average: { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200' },
    poor: { bg: 'bg-red-50', text: 'text-red-700', border: 'border-red-200' },
    high: { bg: 'bg-red-50', text: 'text-red-700', border: 'border-red-200' },
    medium: { bg: 'bg-amber-50', text: 'text-amber-700', border: 'border-amber-200' },
    low: { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200' },
  };
  return colors[status?.toLowerCase()] || colors.info;
}

// Echo status styles
export function getStatusStyles(status) {
  const styles = {
    checked_in: { 
      bg: 'bg-emerald-50', 
      text: 'text-emerald-700', 
      border: 'border-emerald-200',
      dot: 'bg-emerald-500',
      label: 'Checked In'
    },
    in_exam: { 
      bg: 'bg-violet-50', 
      text: 'text-violet-700', 
      border: 'border-violet-200',
      dot: 'bg-violet-500',
      label: 'In Exam'
    },
    checked_out: { 
      bg: 'bg-slate-100', 
      text: 'text-slate-600', 
      border: 'border-slate-200',
      dot: 'bg-slate-400',
      label: 'Checked Out'
    },
    waiting: { 
      bg: 'bg-amber-50', 
      text: 'text-amber-700', 
      border: 'border-amber-200',
      dot: 'bg-amber-500',
      label: 'Waiting'
    },
    scheduled: { 
      bg: 'bg-blue-50', 
      text: 'text-blue-700', 
      border: 'border-blue-200',
      dot: 'bg-blue-500',
      label: 'Scheduled'
    },
    no_show: { 
      bg: 'bg-red-50', 
      text: 'text-red-700', 
      border: 'border-red-200',
      dot: 'bg-red-500',
      label: 'No Show'
    },
  };
  return styles[status] || styles.scheduled;
}

export function getCopayStatusStyles(status) {
  const styles = {
    paid: { bg: 'bg-emerald-50', text: 'text-emerald-700', label: 'Paid' },
    pending: { bg: 'bg-amber-50', text: 'text-amber-700', label: 'Pending' },
    waived: { bg: 'bg-slate-100', text: 'text-slate-600', label: 'Waived' },
  };
  return styles[status] || styles.pending;
}

export function getInsuranceStatusStyles(status) {
  const styles = {
    verified: { bg: 'bg-emerald-50', text: 'text-emerald-700', label: 'Verified' },
    pending: { bg: 'bg-amber-50', text: 'text-amber-700', label: 'Pending' },
    expired: { bg: 'bg-red-50', text: 'text-red-700', label: 'Expired' },
    'n/a': { bg: 'bg-slate-100', text: 'text-slate-600', label: 'N/A' },
  };
  return styles[status] || styles.pending;
}

export const CHART_COLORS = {
  primary: '#000000',
  secondary: '#374151',
  success: '#10b981',
  warning: '#f59e0b',
  error: '#ef4444',
  muted: '#6b7280',
};
